import React, { FC, useEffect, useState } from "react";
import HomePageTitle from "@components/Home/HomePageTitle/HomePageTitle";
import { useTranslation } from "react-i18next";
import { Tab, Tabs } from "@mui/material";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import Albums from "@components/Home/PatientGallery/Albums";
import PageWrapper from "@components/Home/PageWrapper";
import PatientPhotos from "@components/Home/PatientPhotos";

enum PatientGalleryTab {
  Albums = "Albums",
  Photos = "Photos",
}

const PatientGallery: FC = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<PatientGalleryTab>(
    PatientGalleryTab.Albums,
  );

  const location = useLocation();

  useEffect(() => {
    setSelectedTab(
      location?.pathname?.includes("photos")
        ? PatientGalleryTab.Photos
        : PatientGalleryTab.Albums,
    );
  }, [location]);

  return (
    <PageWrapper>
      <HomePageTitle title={t("patientGallery.title")} />
      <Tabs value={selectedTab} sx={{ marginBottom: "32px" }}>
        <Tab
          label={t("patientGallery.albums.title")}
          value={PatientGalleryTab.Albums}
          component={Link}
          to="albums"
        />
        <Tab
          label={t("patientGallery.photos.title")}
          value={PatientGalleryTab.Photos}
          component={Link}
          to="photos"
        />
      </Tabs>

      <Routes>
        <Route path="albums" element={<Albums />} />
        <Route path="photos" element={<PatientPhotos />} />
        <Route path="*" element={<Albums />} />
      </Routes>
    </PageWrapper>
  );
};

export default PatientGallery;
